import { render, staticRenderFns } from "./PaymentMethodModal.vue?vue&type=template&id=75e70fec"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports